import React, { useEffect, useState, useContext } from 'react'
import { useTranslate, useNotify, required } from 'react-admin'
import { Skeleton } from '@mui/material'
import { CheckboxContext } from 'src/components/pages/sales/business-rule/logic/CheckboxContext'
import { EditInputsWrap } from 'src/components/uiElements/CRUD/EditInputsWrap'
import { businessRuleServices } from 'src/services/sales/businessRule/businessRule.service'
import { SelectInput } from 'src/components/uiElements/fields/SelectInput'
import { isInCheckedBoxList } from './helper'

export const GlobalVariables = ({ record }) => {
  const translate = useTranslate()
  const notify = useNotify()
  const { checkedBox, setCheckedBox } = useContext(CheckboxContext)
  const [loadingGlobalVaribles, setLoadingGlobalVaribles] = useState(false)
  const [globalVaribles, setGlobalVaribles] = useState([])

  useEffect(() => {
    getGlobalVaribles()
  }, [])

  const CreateVar = (key, value, show, rule_liquidation_type) => {
    const newChecked = [...checkedBox]
    if (!isInCheckedBoxList(checkedBox, key)) {
      let item = {
        key,
        value: value ? value : 0,
        label: key,
        show: show ? show : false,
        show_sitio: false,
        global_variable: true,
        description: key,
        search: ['var', key, 'value'],
        created: true,
        rule_liquidation_type: rule_liquidation_type || [],
      }
      newChecked.push(item)
      setCheckedBox(newChecked)
    }
  }

  const DeleteVar = (key) => {
    const newChecked = checkedBox.filter((item) => item.key !== key)
    setCheckedBox(newChecked)
  }

  const getGlobalVaribles = async () => {
    try {
      setLoadingGlobalVaribles(true)
      const global_variables = await businessRuleServices.getFormulaGlobalVariables({ limit: 9999 })
      if (global_variables) {
        setGlobalVaribles(global_variables)
      } else setGlobalVaribles([])
    } catch (error) {
      setGlobalVaribles([])
    } finally {
      setLoadingGlobalVaribles(false)
    }
  }

  const onChangeGlobaVariables = (global_variables) => {
    try {
      const selectedIds = global_variables || []
      const filtered = globalVaribles.filter((globalVarible) => selectedIds.includes(globalVarible.id))

      // Detectar variables deseleccionadas y eliminarlas
      const selectedKeys = filtered.map((item) => item.name)
      const removedKeys = checkedBox
        .filter((item) => item.global_variable)
        .map((item) => item.key)
        .filter((key) => !selectedKeys.includes(key))
      removedKeys.forEach((key) => DeleteVar(key))

      // Crear variables seleccionadas
      filtered.forEach((globalVarible) => {
        CreateVar(globalVarible.name, globalVarible.value, globalVarible.show, globalVarible.rule_liquidation_type)
      })
    } catch (error) {}
  }

  return (
    <EditInputsWrap label={translate('ra.field.formula_global_variables')} md={6} lg={4}>
      {loadingGlobalVaribles ? (
        <Skeleton variant='rectangular' width={'100%'} height={40} />
      ) : (
        <SelectInput
          source='formula_global_variables'
          options={globalVaribles}
          label=''
          optionsText={['name', 'value']}
          optionValue='id'
          multiple
          showSearch
          separator=':'
          onChange={(e) => onChangeGlobaVariables(e.target.value)}
          defaultValue={record?.formula_global_variables}
        />
      )}
    </EditInputsWrap>
  )
}
